import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import ModuleVersionStateBadge from "components/ModuleVersionStateBadge";

const ModulesTableVersionCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const isVersionBad = !!module.current?.yanked;
  const infoText = isVersionBad
    ? module.current?.yankNote || "Version was marked as bad"
    : undefined;

  return (
    <TableSimpleCell {...cellProps}>
      <ModuleVersionStateBadge
        state={module.current?.state}
        number={module.current?.number}
        infoText={infoText}
      />
    </TableSimpleCell>
  );
};

export default ModulesTableVersionCell;
